import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const cornerAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.cornerStyles,
);

export default cornerAction;
